<nrwl-identity-verification
    #identityVerification
    [error]="activeError"
    [phoneNumber]="phoneNumber"
    (entered)="onIdentityVerificationEntered($event)" 
    (resend)="onResendClicked($event)">
</nrwl-identity-verification>

<pn-spinner [color]="'#FFFFFF;'" [visible]="isLoading" name="identity_verification_spinner"></pn-spinner>
